import { render } from "./SpeechBubble.vue?vue&type=template&id=57c58fa8&scoped=true"
import script from "./SpeechBubble.vue?vue&type=script&lang=ts"
export * from "./SpeechBubble.vue?vue&type=script&lang=ts"

import "./SpeechBubble.vue?vue&type=style&index=0&id=57c58fa8&lang=less&scoped=true"
import "./SpeechBubble.vue?vue&type=style&index=1&id=57c58fa8&lang=less"
script.render = render
script.__scopeId = "data-v-57c58fa8"

export default script